export class ResumeExcelDownloadState {
	public shouldResumeExcelDownload: boolean = false;
}
